import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./components/app/AppRoutes";
import { Toaster } from 'sonner';
import AppInitializer from "./components/app/AppInitializer";
import { HelmetProvider } from "react-helmet-async";
import { ConfettiProvider } from "./components/ui/confetti-provider";
import { OnboardingProvider } from "./contexts/OnboardingContext";
import { UserProfileRefreshProvider } from "./contexts/UserProfileRefreshContext";
import "./App.css";
import { useToast } from '@/components/ui/use-toast';
import { Toaster as SonnerToaster } from 'sonner';

function App() {
  const { toast } = useToast();
  return (
    <HelmetProvider>
      <Router>
        <UserProfileRefreshProvider>
          <ConfettiProvider>
            <OnboardingProvider>
              <AppInitializer />
              <AppRoutes />
              <Toaster
                position="top-center"
                theme="light"
                style={{ zIndex: 99999, position: 'fixed', pointerEvents: 'auto' }}
                toastOptions={{
                  classNames: {
                    toast: 'bg-[#222] text-white border-none',
                    description: 'text-white',
                    success: 'bg-[#222] text-white',
                    error: 'bg-red-600 text-white',
                  },
                }}
              />
            </OnboardingProvider>
          </ConfettiProvider>
        </UserProfileRefreshProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
